// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1ISMT","title":"Images45_title__2DtXo","images":"Images45_images__3wzMH"};